import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./login.css";
import { ValidateInput } from "../../components/helpers/validateInput";
import { NotificationManager } from "react-notifications";
import { httpPost } from "../../components/helpers/httpMethods";
import { hideLoader, showLoader } from "../../components/helpers/loader";
import { setLocalItem } from "../../components/helpers/authService";
import Logo from "../../assets/images/appLogo.png";
import LogoWhite from "../../assets/images/appLogo2V2.png";
import swal from "sweetalert";
import SEO from "../../components/Layout/SEO";

export default function Login(props) {
  const [userAccount, setUserAccount] = useState({ email: "", password: "" });
  const [errorInput, setErrorInput] = useState({ email: "", password: "" });
  const [showPass, setShowPass] = useState(false);

  const checkUserLoginState = () => {
    const loginSt = localStorage.getItem("expiredToken");
    if (loginSt === "true") return;
  };

  const handleChange = (e) => {
    setUserAccount({ ...userAccount, [e.target.name]: e.target.value });
    let testValid = ValidateInput(e.target.value);
    setErrorInput({ ...errorInput, [e.target.name]: testValid });
  };

  const checkAcess = (value) => {
    const regexFormat = /^[[0-9+-]+$/;
    return regexFormat.test(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let t = checkAcess(userAccount.email);
    if (errorInput.email !== "Looks Good!")
      return swal("Error", "Email or Mobile number is required", "error");
    if (errorInput.password !== "Looks Good!")
      return swal("Error", "Password is required", "error");
    showLoader();
    const data = t === false
      ? { email: userAccount.email, password: userAccount.password }
      : { phoneNumber: userAccount.email, password: userAccount.password };
    const checkFrom = localStorage.getItem("comingFromPublicPublication");
    const rediretURL = localStorage.getItem("rediretURL");
    let res = await httpPost("auth/user_login", data);
    if (res) {
      if (res.er) { NotificationManager.error(res.er.message); return; }
      setUserAccount({ email: "", password: "" });
      localStorage.setItem("token", res.data.token);
      setLocalItem("user", res.data.user);
      localStorage.setItem("expiredToken", "false");
      NotificationManager.success(`Welcome Back ${res.data.user.firstName}.`);
      if (checkFrom === "true") {
        localStorage.setItem("comingFromPublicPublication", "false");
        props.history.push(`/publication/${rediretURL}`);
      } else {
        props.history.push("/");
      }
      hideLoader();
    }
    hideLoader();
  };

  useEffect(() => { checkUserLoginState(); }, []);

  return (
    <>
      <SEO
        title="TheNewspaperStand (TNS) | Login"
        description="Login to TheNewspaperStand to access digital Nigerian newspapers and magazines."
        url="https://newstand.tech/login"
        noindex
      />
      <div className="login-wrap-v2">

        {/* LEFT PANEL */}
        <div className="login-wrap-v2-col1">
          <div className="login-col1-top">
            <img src={LogoWhite} alt="TNS Logo" className="login-col1-logo" />
          </div>
          <div className="heroTextSection">
            <h1>Nigeria's #1<br /><span>Digital Newsstand</span></h1>
            <ul className="hero-bullets">
              <li>Zero Paper Litter</li>
              <li>Read on any device, anywhere</li>
              <li>80% cheaper than print</li>
              <li>Your personal e-library, forever</li>
              <li>500+ publications in one place</li>
            </ul>
            <Link to="/create_account">
              <button className="hero-cta-btn">Get Started Free</button>
            </Link>
          </div>
          <div className="login-col1-badge">
            <p><strong>50,000+</strong> readers trust TNS for their daily news</p>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="login-wrap-v2-col2">
          <div className="login-top-bar">
            <Link to="/" className="login-back-btn">
              ← Back to Home
            </Link>
            <div className="signUpOptonLogin">
              <p>Don't have an account? <span><Link to="/create_account">Sign up</Link></span></p>
            </div>
          </div>

          <div className="mobileViewLogoV2">
            <img src={Logo} alt="TNS Logo" />
          </div>

          <div className="login-wrapv2-main">
            <h1 className="login-txt-header">Welcome back</h1>
            <p className="login-subheader">Sign in to your TNS account</p>

            <form>
              <div className="inputWrap-v2">
                <label>Email Address or Mobile Number</label>
                <input
                  type="text"
                  placeholder="Enter your email or phone number"
                  name="email"
                  onChange={handleChange}
                  value={userAccount.email}
                  required
                />
              </div>

              <div className="inputWrap-v2">
                <label>Password</label>
                <input
                  type={showPass ? "text" : "password"}
                  name="password"
                  onChange={handleChange}
                  placeholder="Enter your password"
                  value={userAccount.password}
                  required
                />
              </div>

              <div className="forgotPasswordOptionv2">
                <p><Link to="/forgot_password">Forgot password?</Link></p>
              </div>

              <div className="loginBtnV2">
                <button onClick={handleSubmit}>Sign In</button>
              </div>

              <div className="haveanAccountV2Op">
                <p>New to TNS? <Link to="/create_account">Create an account</Link></p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
